export const generateXHRError = (e) => {
  const DEFAULT_MSG = 'Sorry, something went wrong!';
  const { data } = e.response || {};

  if (data && typeof data === 'object') {
    return data.message || data.Message || DEFAULT_MSG;
  }
  if (data && typeof data !== 'object') {
    return data;
  }
  return DEFAULT_MSG;
};

export default {};
